import { StrictLocalMsg } from "@faire/localization/react/StrictLocalMsg";
import { getStrictLocalMsgChildren } from "@faire/slate/lib/getStrictLocalMsgChildren";
import { tsv } from "@faire/slate/lib/tsv";
import type { InstanceOfComponent } from "@faire/slate/private/shared/types";
import React from "react";

import { ACCORDION_LABEL_ALLOWED_CHUNK_TRANSFORM_KEYS } from "./consts";
import { AccordionLabelVariant } from "./types";

type IProps = Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "className" | "children"
> & {
  variant: AccordionLabelVariant;
  children: string | InstanceOfComponent<typeof StrictLocalMsg>;
};

export const AccordionItemLabel: React.FC<IProps> = ({
  variant,
  children,
  ...props
}) => {
  let label: string | React.JSX.Element[];

  if (typeof children === "string") {
    label = children;
  } else {
    const [{ strictLocalMsgs }, rest] = getStrictLocalMsgChildren(
      children,
      ACCORDION_LABEL_ALLOWED_CHUNK_TRANSFORM_KEYS
    );
    if (rest.length > 0) {
      // oxlint-disable-next-line no-console
      console.error(
        `AccordionItemLabel only accepts the following chunk transforms: ${ACCORDION_LABEL_ALLOWED_CHUNK_TRANSFORM_KEYS.map((key) => `chunkTransformations.${key}`).join(", ")}`
      );
    }
    label = strictLocalMsgs;
  }

  return (
    <div {...props} className={labelStyle.cls({ variant })}>
      {label}
    </div>
  );
};

const labelStyle = tsv({
  base: "fs-accordion__label",
  variants: {
    variant: {
      paragraph: "fs-accordion__label--paragraph",
      subheading: "fs-accordion__label--subheading",
    },
  },
});
